import type React from 'react';
import { FolderTree, Tag } from 'lucide-react';
import CategorySelector from 'src/features/createProduct/screens/CreateProduct/components/CategorySelect';
import InputTags from 'src/features/createProduct/screens/CreateProduct/components/InputsTags';

interface CategoriesTagsProps {
  categoryOptions: any[];
  selectedCategories: any[];
  inputTags: string[];
  onSelectCategory: (e: React.FocusEvent<HTMLSelectElement>) => void;
  onRemoveCategory: (value: string) => void;
  onAddTag: (tag: string) => void;
  onRemoveTag: (value: string) => void;
}

const CategoriesTags: React.FC<CategoriesTagsProps> = ({
  categoryOptions,
  selectedCategories,
  inputTags,
  onSelectCategory,
  onRemoveCategory,
  onAddTag,
  onRemoveTag,
}) => {
  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="p-3 rounded-xl bg-gradient-to-br from-primary/10 to-primary/5 border border-primary/20">
            <FolderTree className="h-6 w-6 text-primary" />
          </div>
          <h2 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
            Categorias e Tags
          </h2>
        </div>
        <p className="text-muted-foreground text-base ml-[60px]">
          Organize seu produto com categorias e tags relevantes para melhor
          descoberta
        </p>
      </div>

      {/* Card Principal */}
      <div className="bg-card rounded-2xl border-2 border-border shadow-lg hover:shadow-xl transition-shadow duration-300">
        {/* Seção Categorias */}
        <div className="p-8 space-y-4">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-primary/10">
              <FolderTree className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">
                Categorias
              </h3>
              <p className="text-sm text-muted-foreground">
                Classifique seu produto nas categorias apropriadas
              </p>
            </div>
          </div>

          <CategorySelector
            categorys={categoryOptions}
            selectedCategories={selectedCategories}
            selectCategory={onSelectCategory}
            removeCategory={onRemoveCategory}
            error={
              selectedCategories.length === 0
                ? 'Selecione pelo menos uma Categoria'
                : null
            }
          />
        </div>

        {/* Divisor com gradiente */}
        <div className="h-px bg-gradient-to-r from-transparent via-border to-transparent mx-8" />

        {/* Seção Tags */}
        <div className="p-8 space-y-4">
          <div className="flex items-center gap-3 mb-6">
            <div className="p-2 rounded-lg bg-primary/10">
              <Tag className="h-5 w-5 text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-foreground">Tags</h3>
              <p className="text-sm text-muted-foreground">
                Adicione palavras-chave para facilitar a busca
              </p>
            </div>
          </div>

          <InputTags
            tags={inputTags}
            addTag={onAddTag}
            removeTag={onRemoveTag}
            error={
              inputTags.length === 0 ? 'Adicione pelo menos uma tag.' : null
            }
            inputClassName="rounded-xl px-4 py-3 w-full bg-background border-2 border-input 
                           focus:border-primary focus:ring-4 focus:ring-primary/10
                           transition-all duration-300 outline-none"
          />
        </div>
      </div>
    </div>
  );
};

export default CategoriesTags;
